import { render } from "./MyAccountRoomsHistory.vue?vue&type=template&id=723bf0a4&scoped=true"
import script from "./MyAccountRoomsHistory.vue?vue&type=script&lang=js"
export * from "./MyAccountRoomsHistory.vue?vue&type=script&lang=js"

import "./MyAccountRoomsHistory.vue?vue&type=style&index=0&id=723bf0a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723bf0a4"]])

export default __exports__